import { __rest } from "tslib";
import { h } from '@stencil/core';
import { isRoutingDisabled } from './utils';
import { passBreadcrumbsParams } from '../breadcrumbs/utils';
const RouterLinkView = (props, children) => {
  const { name, url, pageId, pageName, linkClassName, target, storageName, breadcrumbs, } = props;
  const storeBreadcrumbsParams = {
    id: pageId,
    name,
    url,
    storageName,
    breadcrumbs,
    pageName,
  };
  if (isRoutingDisabled(props)) {
    return (h("a", { class: linkClassName, href: url, target: target !== null && target !== void 0 ? target : '_self', onClick: passBreadcrumbsParams(storeBreadcrumbsParams) }, children));
  }
  const _a = props, { routerClassName } = _a, routerProps = __rest(_a, ["routerClassName"]);
  return (h("pes-router-link", Object.assign({ key: pageId, class: routerClassName }, routerProps, { saveInIndexDB: passBreadcrumbsParams(storeBreadcrumbsParams) }), h("a", { class: linkClassName, href: "#" }, children)));
};
export default RouterLinkView;
